import { GeolocationAccuracyLevel } from "@/services/geolocationService";
import { TFunction } from "i18next";

export const getSuccessMessageWithGeolocation = (
  baseMessage: string,
  accuracyLevel: GeolocationAccuracyLevel,
  t: TFunction,
): string => {
  let successMessage = baseMessage;

  if (accuracyLevel === GeolocationAccuracyLevel.LOW) {
    successMessage = `${baseMessage} ${t("contractorVisits.success.geolocationLowAccuracy")}`;
  } else if (accuracyLevel === GeolocationAccuracyLevel.ERROR) {
    successMessage = `${baseMessage} ${t("contractorVisits.success.geolocationFailed")}`;
  }

  return successMessage;
};
